import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col justify-start items-stretch" }
const _hoisted_2 = { class: "flex-1 max-sm:ml-8 sm:mx-8 py-6 space-y-4 overflow-x-auto" }
const _hoisted_3 = { class: "flex flex-row items-center justify-around flex-nowrap gap-5" }
const _hoisted_4 = { class: "flex-1 relative max-sm:min-w-24" }
const _hoisted_5 = { class: "max-md:hidden absolute right-0 inset-y-0 flex items-center justify-center px-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "max-md:hidden" }, " Contatos", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "max-md:hidden" }, " Contato", -1)
const _hoisted_8 = { class: "grid grid-rows-6 grid-cols-1 gap-2" }

import HeaderComponent from '@/components/HeaderComponent.vue';
import Button from '@/components/ui/button/Button.vue';
import Input from '@/components/ui/input/Input.vue';
import Skeleton from '@/components/ui/skeleton/Skeleton.vue';
import { Search } from 'lucide-vue-next';

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactsView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent, {
      class: "flex-1 flex-grow-0 min-w-60",
      title: "Contatos"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Input, {
            id: "search",
            type: "text",
            placeholder: "Pesquisar"
          }),
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_unref(Search), { class: "size-6 text-muted-foreground" })
          ])
        ]),
        _createVNode(Button, {
          class: "rounded-full",
          variant: "outline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Importar"),
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(Button, {
          class: "rounded-full",
          variant: "default"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Adicionar"),
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6], (i) => {
          return _createElementVNode("div", {
            key: i,
            class: "grid grid-rows-1 grid-cols-4 gap-2"
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4], (j) => {
              return _createVNode(Skeleton, {
                key: j,
                class: "w-full h-8 col-span-1"
              })
            }), 64))
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})